import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import news from './modules/news'
import trade from './modules/trade'
import data from './modules/data'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    news,
    trade,
    data
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js